import { Link } from '@tanstack/react-router';
import { ArrowRight, LineChart } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import { Button } from '@/_components';
import { CardContainer, SectionHeading } from '@/_containers';
import { dashboardWidgetsPermissionConfig } from '@/_shared';

export function Layout({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <CardContainer className={twMerge('h-full', className)} bodyClassName="3xl:px-4 px-4 pb-0" right>
      <SectionHeading text={dashboardWidgetsPermissionConfig['financial_snapshot'].name} icon={LineChart} />
      <div className="mt-6">{children}</div>
      <section className="py-2 pr-0 text-right">
        <Link to="/financial-snapshots">
          <Button as="link" size="xs" iconRight={ArrowRight}>
            View All Financial Snapshots
          </Button>
        </Link>
      </section>
    </CardContainer>
  );
}
